import * as moment from 'moment';
import { SubsidyCapType } from '@trnsact/trnsact-shared-types';
import {
  FinanceProgramFormValues,
  MarkupMethods,
  MarkupType,
  PaymentCalculationMethods,
  SaleType,
  SendVia,
  Structures,
} from '../types';
import { FinanceProgramType, FinanceProgramRateType } from '@trnsact/trnsact-shared-types';

export const sendViaInitialValues: FinanceProgramFormValues['sendVia'] = {
  type: SendVia.Email,
};

export const displaySettingsInitialValues: FinanceProgramFormValues['displaySettings'] = {
  productPrice: true,
  productDetails: true,
  showLenderLogo: false,
  showLenderName: false,
  showInterestRate: true,
  showBestOptions: false,
  shouldRedirectToOCA: true,
  excludeEquipmentSales: false,
  lenderProfileId: '',
  showFinanceProgramDescription: true,
};

export const contactInitialValues: FinanceProgramFormValues['contact'] = {
  email: '',
  phone: '',
  state: '',
  title: '',
  selectedContact: '',
  fullName: null,
  businessName: null,
  dealerLocation: null,
  assignDealer: null,
};

export const equipmentInitialValues: FinanceProgramFormValues['equipment'] = {
  selectedEquipment: '',
  make: '',
  class: '',
  year: '',
  model: '',
  stockId: '',
  newUsed: '',
  mileage: '',
  quantity: '1',
  description: '',
  retailPrice: '',
  serialNumberVin: '',
  totalWholesaleCost: '',
};

export const saleDetailsInitialValues: FinanceProgramFormValues['saleDetails'] = {
  netRate: 0,
  financeAmount: 0,
  fees: 0,
  invoiceTotal: 0,
  salesTax: 0,
  equipmentSubtotal: 0,
  saleType: SaleType.Financing,
  downPayment: { flat: 0, percent: 0 },
};

export const financeQuoteInitialValues: FinanceProgramFormValues['financeQuote'] = {
  fee: [],
  menu: '',
  amount: 0,
  commonRate: 0,
  terms: [],
  program: '',
  residual: 0,
  markupRate: 0,
  programName: '',
  specifyRates: [],
  dealerMarkup: 0,
  advancePayment: '',
  daysToFirstPayment: '30',
  minimumRequiredDownPayment: 0,
  startDate: moment.default(new Date()).format('YYYY-MM-DD'),
  firstPaymentDate: moment.default(new Date()).add(30, 'days').format('YYYY-MM-DD'),
  specifyRate: false,
  specifyRatePerTerm: 0,
  structure: Structures.None,
  subsidyType: MarkupType.Flat,
  configureSubsidyCap: false,
  specifyLenderMarketRates: [],
  subsidyCapConfiguration: undefined,
  maxApprovalAmount: 0,
  commonLenderMarketRate: 0,
  customTermTemporaryValue: null,
  programType: FinanceProgramType.Loan,
  createProposalWithExistingProgram: null,
  markupMethod: MarkupMethods.MarkupDollar,
  rateType: FinanceProgramRateType.InterestRate,
  paymentCalculationMethod: PaymentCalculationMethods.Advance,
  selectedSubmissionId: null,
};

export const submissionInitialValues: FinanceProgramFormValues['submission'] = {
  selectedSubmissionId: '',
  maxApprovalAmount: null,
};

export const financeProgramDescriptionInitialValues: FinanceProgramFormValues['financeProgramDescription'] = {
  apiValue: '',
  editorValue: null,
};

export const formInitialValues: FinanceProgramFormValues = {
  sendVia: sendViaInitialValues,
  contact: contactInitialValues,
  equipment: equipmentInitialValues,
  saleDetails: saleDetailsInitialValues,
  financeQuote: financeQuoteInitialValues,
  submission: submissionInitialValues,
  displaySettings: displaySettingsInitialValues,
  ccEmail: [],
  financeProgramDescription: financeProgramDescriptionInitialValues,
};
